import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [paymentStatus, setPaymentStatus] = useState('checking');

  const checkPaymentStatus = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/payments/status/${sessionId}`);
      setPaymentStatus(response.data.payment_status);
    } catch (error) {
      console.error('Error checking payment status:', error);
      setPaymentStatus('error');
    }
  }, [sessionId]);

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId, checkPaymentStatus]);

  return (
    <div data-testid="payment-success-page" className="min-h-screen pt-20 flex items-center justify-center bg-white">
      <div className="max-w-md mx-auto px-4 text-center">
        <div className="bg-[#F9F6F0] p-12 rounded-lg">
          <CheckCircle size={64} className="text-green-600 mx-auto mb-6" />
          <h1 className="text-3xl font-serif text-[#1A1A1A] mb-4">
            Pagamento Confermato!
          </h1>
          <p className="text-[#666666] mb-8 leading-relaxed">
            Il tuo pagamento è stato elaborato con successo. Riceverai una email di conferma a breve.
          </p>
          <Link
            to="/"
            data-testid="back-home-link"
            className="inline-block bg-[#2C5263] text-white px-8 py-3 rounded-md text-base font-medium hover:bg-[#1A3644] transition-colors"
          >
            Torna alla Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
